import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { TYPE, CheckBox } from "components/Form";

/**
 * NotificationPreferenceCheckbox
 *
 * @param {String} name - The name of the checkbox input
 * @param {Boolean} value - The current value of the checkbox input
 * @param {Function} onChange - The function to call when the checkbox value changes
 * @param {String} labelId - The ID of the label message for the checkbox
 * @param {String} descriptionId - The ID of the description message for the checkbox
 *
 * @returns {JSX.Element} - A checkbox input with a label and description for notification preferences
 */
const NotificationPreferenceCheckbox = ({
  name = "shouldNotify",
  value = false,
  onChange,
  labelId = "Missions.Applicants.Notification.SendCheckbox",
  descriptionId = "Missions.Applicants.Notification.SendCheckboxDescription",
  ...props
}) => (
  <CheckBox
    name={name}
    value={value}
    onChange={onChange}
    label={<FormattedMessage id={labelId} />}
    description={<FormattedMessage id={descriptionId} />}
    {...props}
  />
);

const getNotificationPreferenceCheckboxItem = ({
  name = "shouldNotify",
  labelId = "Missions.Applicants.Notification.SendCheckbox",
  descriptionId = "Missions.Applicants.Notification.SendCheckboxDescription",
} = {}) => ({
  type: TYPE.checkbox,
  properties: {
    name,
    label: <FormattedMessage id={labelId} />,
    description: <FormattedMessage id={descriptionId} />,
  },
});

NotificationPreferenceCheckbox.propTypes = {
  name: PropTypes.string,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  labelId: PropTypes.string,
  descriptionId: PropTypes.string,
};

export default NotificationPreferenceCheckbox;

export { getNotificationPreferenceCheckboxItem };
